import {
  CategoryAction
} from '../const';
import {
  getResponseByMode,
  start,
  end,
  showMessage,
  logMessage
} from '../utils';
import {
  setStartParam
} from './params';

export class Loadmore {
  constructor(container) {
    this._pagination = container.querySelector('.category__pagination');
    this._button = this._pagination.querySelector('.category__button');

    this._buttonClickHandler = this._buttonClickHandler.bind(this);
  }

  setButtonClickHandler(callback) {
    this._callback = callback;
    if (this._button) {
      this._button.addEventListener('click', this._buttonClickHandler);
    }
  }

  _getLoadmoreLink() {
    const activeElem = this._pagination.querySelector('.pagination__link--active');
    const nextElem = activeElem.parentNode.nextElementSibling.children[0];
    return nextElem.href;
  }

  _buttonClickHandler() {
    const mock = {
      url: 'mocks/products.html',
      options: {
        method: 'GET'
      }
    };

    const formData = new FormData();
    formData.set('ajax', 1);

    const real = {
      url: this._getLoadmoreLink(),
      options: {
        method: 'POST',
        body: formData
      }
    };

    const {
      url,
      options
    } = getResponseByMode(mock, real);

    start();

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`Не получилось обновить товары`);
      })
      .then((str) => {
        this._callback(CategoryAction.LOADMORE, str);
        setStartParam(url);
      })
      .catch((error) => {

        logMessage(error);
        showMessage(error.message);
      })
      .finally(() => {
        end();
      });

  }
}
